export default "__VITE_PUBLIC_ASSET__4fce1592__"